import React, {useState} from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
    ClickAwayListener,
    Tooltip,
    makeStyles,
    Button, FormHelperText
} from '@material-ui/core';
import { KeyboardBackspace as KeyboardBackspaceIcon, Help as HelpIcon } from '@material-ui/icons';

import routes from 'routes';
import roles from 'roles';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4)
    },
    formControl: {
        minWidth: 120,
        width: '100%',
    },
    button: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1)
    },
    customWidthTooltip: {
        maxWidth: '500',
        fontSize: '0.85rem'
    },
}));

function UserCreateComponent(props) {

    const { currentUser } = useSelector(state => state.users);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [agency, setAgency] = useState(
        currentUser.agencyId === null ? '' : currentUser.agencyId
    );
    const [role, setRole] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [tempPassword, setTempPassword] = useState('');
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(true);

    const {error} = props;

    const history = useHistory();
    const classes = useStyles();

    const handleSubmit = (event) => {
        event.preventDefault();
        props.saveUser({ name, email, agencyId: agency, role, phone: phoneNumber, tempPassword, active });
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={4}>
                <Grid item xs={12} md={10} lg={8} xl={6}>
                    <Card>
                        <CardHeader
                            avatar={
                                <IconButton aria-label='Go Back' edge='start' onClick={() => history.goBack()}>
                                    <KeyboardBackspaceIcon/>
                                </IconButton>
                            }
                            title='Add User'
                            titleTypographyProps={{ variant: 'h5' }}
                            subheaderTypographyProps={{ variant: 'body1' }}
                            subheader='Complete the following fields and select create to add a new user to your agency!'
                        />
                        <Divider/>
                        <CardContent>
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} error={false}>
                                            <TextField
                                                required
                                                id='user-name'
                                                label='Name'
                                                value={name}
                                                size='small'
                                                onChange={event => setName(event.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} >
                                            <TextField
                                                error={error.field === 'email'}
                                                required
                                                id='user-email'
                                                label='Email Address'
                                                value={email}
                                                size='small'
                                                helperText={error.field === 'email' ? error.message: ''}
                                                onChange={event => setEmail(event.target.value.trim())}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} error={false}>
                                            <TextField
                                                id='user-phone-number'
                                                label='Phone Number'
                                                value={phoneNumber}
                                                size='small'
                                                onChange={event => setPhoneNumber(event.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} required error={false}>
                                            <InputLabel id='agency-select-label'>Agency</InputLabel>
                                            <Select
                                                labelId='agency-select-label'
                                                id='agency-select'
                                                value={agency}
                                                onChange={event => setAgency(event.target.value)}
                                                size='small'
                                                required
                                            >
                                                {props.isLoadingAgencies ? (
                                                    <MenuItem value="" disabled>Loading...</MenuItem>
                                                ) : (
                                                    props.agencies.map(agency => (
                                                        <MenuItem key={agency.agencyId} value={agency.agencyId}>{agency.agencyName}</MenuItem>
                                                    ))
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} required error={false}>
                                            <InputLabel id='role-select-label'>Role</InputLabel>
                                            <Select
                                                labelId='role-select-label'
                                                id='role-select'
                                                value={role}
                                                onChange={event => setRole(event.target.value)}
                                                size='small'
                                                required
                                            >
                                                {Object.keys(roles).filter((role) => roles[role].level <= roles[currentUser.role].level).map(role => (
                                                    <MenuItem key={roles[role].name} value={roles[role].name}>{roles[role].displayName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} error={error.field === "password"} >
                                            <InputLabel htmlFor='standard-adornment-password' required>Temporary Password</InputLabel>
                                            <Input
                                                required
                                                id='standard-adornment-password'
                                                type='text'
                                                size='small'
                                                value={tempPassword}
                                                onChange={event => setTempPassword(event.target.value)}
                                                endAdornment={
                                                    <ClickAwayListener onClickAway={() => setOpen(false)}>
                                                        <Tooltip
                                                            placement='left-start'
                                                            classes={{ tooltip: classes.customWidthTooltip }}
                                                            onClose={() => setOpen(false)}
                                                            open={open}
                                                            arrow
                                                            title={`Password must be 8 characters and include
                                                             one upper, one lower, one number, and one symbol.`}
                                                        >
                                                            <InputAdornment position='end'>
                                                                <IconButton onClick={() => setOpen(true)}>
                                                                    <HelpIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Tooltip>
                                                    </ClickAwayListener>
                                                }
                                            />
                                            <FormHelperText id='password-error-text'>{error.field === 'password'?error.message: ''}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} required error={false}>
                                            <InputLabel id='user-status-label'>Status</InputLabel>
                                            <Select
                                                labelId='user-status-label'
                                                id='user-status'
                                                size='small'
                                                value={active}
                                                onChange={event => setActive(event.target.value)}
                                            >
                                                <MenuItem value={true}>Active</MenuItem>
                                                <MenuItem value={false}>Inactive</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid container item justify='flex-end' xs={12}>
                                        <Button variant='text' className={classes.button} onClick={() => history.push(routes.users.path)}>
                                            Cancel
                                        </Button>
                                        <Button variant='contained' color='secondary' type='submit' className={classes.button}
                                            disabled={!name || !email || !agency || !role || !tempPassword}>
                                            Create
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
}

UserCreateComponent.propTypes = {
    agencies: PropTypes.array,
    isLoadingAgencies: PropTypes.bool,
    roles: PropTypes.object,
    saveUser: PropTypes.func,
    error: PropTypes.object,
};

export default UserCreateComponent;
